export default __webpack_public_path__ + "9b821eea5f86b7ad974b0f51085c0e12.png";